const data = {
  data: [
    {
      id: 1,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Certificate 1',
      serial: '1234567',
      expires_at: '2021-05-25T15:33:57.000000Z',
      file: ''
    },
    {
      id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Certificate 2',
      serial: '1234567',
      expires_at: '2021-05-25T15:33:57.000000Z',
      file: ''
    },
    {
      id: 3,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Certificate 3',
      serial: '1234567',
      expires_at: '2021-05-25T15:33:57.000000Z',
      file: ''
    },
    {
      id: 4,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Certificate 4',
      serial: '1234567',
      expires_at: '2021-05-25T15:33:57.000000Z',
      file: ''
    },
    {
      id: 5,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      name: 'Certificate 5',
      serial: '1234567',
      expires_at: '2021-05-25T15:33:57.000000Z',
      file: ''
    }
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
